
<div class="vehicle-select__list" [formGroup]="selectForm">
    <div
    class="vehicle-select__item"
    [class.vehicle-select__item--loading]="loading"

>

    <select
        class="vehicle-select__item-control"
        placeholder = "Select Category"
        formControlName="categoryId"
        (change)="getSubCategory($event)"
    >
    <option [value]="0" >Select Category</option>
        <option *ngFor="let data of categoryData" [value]="data.id">
            {{ data.name }}
        </option>
    </select>
    <div class="vehicle-select__item-loader"></div>
    </div>
    <div
    class="vehicle-select__item"
    [class.vehicle-select__item--loading]="subCategoryLoading"

>

    <select
        class="vehicle-select__item-control"
        formControlName="subCategoryId"
        (change)="getUniqueCourse($event)"


    >
    <option [value]="0" selected>Select Sub Category</option>
        <option *ngFor="let data of subCategoryData" [value]="data.id">
            {{ data.name }}
        </option>
    </select>
    <div class="vehicle-select__item-loader"></div>
    </div>
    <div
    class="vehicle-select__item"
    [class.vehicle-select__item--loading]="uniqueCourseLoading"

>
    <select
        class="vehicle-select__item-control"
        formControlName="uniqueCourseId"
        (click)="unique($event)"

    >
    <option [value]="0" selected>Select Sub Category</option>
        <option *ngFor="let data of uniqueCourseData" [value]="data.id">
            {{ data.name }}
        </option>
    </select>
    <div class="vehicle-select__item-loader"></div>
    </div>
</div>
